var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-income-report" },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                        on: { click: _vm.goPrevious },
                      },
                      [
                        _c("img", {
                          staticClass: "left-nav",
                          attrs: {
                            src: require("@/assets/packageAssets/common/arrow05.png"),
                            alt: "",
                          },
                        }),
                        _c("span", { staticClass: "tit-left" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("lang.mybean.incomeReport")) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "search-select",
                        on: { click: _vm.handleTimePop },
                      },
                      [
                        _vm.chooseTime
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.handleMoment(_vm.chooseTime, "YYYY-MM-DD")
                                )
                              ),
                            ])
                          : _c("span", [
                              _vm._v(_vm._s(_vm.$t("lang.dl.thisWeek"))),
                            ]),
                        _c("img", {
                          class: { activeTime: _vm.showPop },
                          attrs: {
                            src: require("@/assets/packageAssets/common/arrow06.png"),
                            alt: "",
                          },
                        }),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          { staticClass: "myincome-list" },
          _vm._l(_vm.list.keys(), function (key) {
            return _c(
              "div",
              {
                key: key,
                staticClass: "list-item",
                class: {
                  todayIncome: key == _vm.$t("lang.mybean.todaytIncome"),
                  lineBottom:
                    key == _vm.$t("lang.mybean.todaytIncome") ||
                    key == _vm.$t("lang.mybean.others"),
                },
              },
              [
                _c("span", [_vm._v(_vm._s(key))]),
                _c("div", { staticClass: "myincome-beans" }, [
                  _c("i", [_vm._v(_vm._s(_vm.list.get(key)))]),
                  _c("img", {
                    attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                  }),
                ]),
              ]
            )
          }),
          0
        ),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("lang.mybean.todayPerformance"))),
        ]),
        _c("div", { staticClass: "performance-data" }, [
          _c("div", { staticClass: "perfor-item" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.transformSeconds5(_vm.data.onlineDuration))),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.mybean.onlineDuration")))]),
          ]),
          _c("div", { staticClass: "perfor-item" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.transformSeconds5(_vm.data.videoCallDuration))),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.earnRule.callDuration")))]),
          ]),
          _c("div", { staticClass: "perfor-item" }, [
            _c("span", [_vm._v(_vm._s(_vm.data.repliedUsersCount))]),
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.mybean.repliedUsers")))]),
          ]),
        ]),
        _c(
          "table",
          {
            staticClass: "table",
            attrs: { cellspacing: "0", cellpadding: "0" },
          },
          [
            _c("tr", [
              _c(
                "td",
                { staticClass: "video-call-ms", attrs: { rowspan: "5" } },
                [_vm._v(_vm._s(_vm.$t("lang.mybean.videoCall")))]
              ),
              _c("td", [
                _c("div", { staticClass: "td-con" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.mybean.privateCallTimes"))),
                  ]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.data.privateCallSuccessTimes)),
                  ]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", [
                _c("div", { staticClass: "td-con" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.mybean.matchCallTimes"))),
                  ]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.data.videoPassTodayIncomeAmount)),
                  ]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", [
                _c("div", { staticClass: "td-con" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.mybean.missedCallTimes"))),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.data.missedCallTimes))]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", [
                _c("div", { staticClass: "td-con" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.mybean.answerRate"))),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.data.answeringRate) + "%")]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", [
                _c("div", { staticClass: "td-con" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.mybean.videoCallDuration"))),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(this.transformSeconds4(_vm.data.videoCallDuration))
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c(
                "td",
                { staticClass: "video-call-ms", attrs: { rowspan: "6" } },
                [_vm._v(_vm._s(_vm.$t("lang.mybean.message")))]
              ),
              _c("td", [
                _c("div", { staticClass: "td-con" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.mybean.sentMessage"))),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.msgInfo.sendMsgCount))]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", [
                _c("div", { staticClass: "td-con" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.mybean.messageReceived"))),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.msgInfo.receivedCount))]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", [
                _c("div", { staticClass: "td-con" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.mybean.profitableMessage"))),
                  ]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.msgInfo.profitableMessagesCount)),
                  ]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", [
                _c("div", { staticClass: "td-con" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.mybean.chatUsers")))]),
                  _c("span", [_vm._v(_vm._s(_vm.msgInfo.chatUsersCount))]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", [
                _c("div", { staticClass: "td-con" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.mybean.repliedUsers"))),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.msgInfo.repliedUsersCount))]),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", [
                _c("div", { staticClass: "td-con" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.mybean.messageReplyRate"))),
                  ]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.msgInfo.chatUsersRepliedRate) + "%"),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
        _c("div", { staticClass: "tips" }, [
          _vm._v(_vm._s(_vm.$t("lang.mybean.tips"))),
        ]),
        _c("div", { staticClass: "tips tips-text" }, [
          _vm._v(_vm._s(_vm.$t("lang.mybean.tipsText"))),
        ]),
      ]),
      _c("TimeDay", {
        attrs: { showPop: _vm.showPop },
        on: { handleCurrentDate: _vm.handleCurrentDate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }